import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardPage from "./pages/Dashboard";
import DashboardEntryGate from "./pages/DashboardEntryGate";
import AnnualOverviewPage from "./pages/AnnualOverview";
import CardTransactionsPage from "./pages/CardTransactions";
import SavingsPlanPage from "./pages/SavingsPlan";
import DashboardSettingsPage from "./pages/DashboardSettings";
import AccountPage from "./pages/AccountPage";
import AdminMetricsPage from "./pages/AdminMetrics";
import OAuthCallbackPage from "./pages/OAuthCallback";
import WhatAppDoesPage from "./pages/public/WhatAppDoesPage";
import GetStartedFiveMinutesPage from "./pages/public/GetStartedFiveMinutesPage";
import PricingLimitsPage from "./pages/public/PricingLimitsPage";
import PrivacyNoBankConnectionPage from "./pages/public/PrivacyNoBankConnectionPage";
import LegalNoticePage from "./pages/legal/LegalNoticePage";
import PrivacyCookiesPage from "./pages/legal/PrivacyCookiesPage";
import TermsSubscriptionPage from "./pages/legal/TermsSubscriptionPage";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { PublicRoute } from "./routes/PublicRoute";
import SiteFooter from "./components/common/SiteFooter";
import CookieBanner from "./components/common/CookieBanner";

function App() {
  return (
    <div className="app-container">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/auth/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path="/auth/register"
          element={
            <PublicRoute>
              <RegisterPage />
            </PublicRoute>
          }
        />
        <Route
          path="/auth/forgot-password"
          element={
            <PublicRoute>
              <ForgotPasswordPage />
            </PublicRoute>
          }
        />
        <Route
          path="/auth/reset-password"
          element={
            <PublicRoute>
              <ResetPasswordPage />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardEntryGate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/movimientos"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/analisis"
          element={
            <ProtectedRoute>
              <AnnualOverviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/analisis/tarjetas"
          element={
            <ProtectedRoute>
              <CardTransactionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/plan-ahorro"
          element={
            <ProtectedRoute>
              <SavingsPlanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/configuracion"
          element={
            <ProtectedRoute>
              <DashboardSettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/mi-cuenta"
          element={
            <ProtectedRoute>
              <AccountPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin-metrics"
          element={
            <ProtectedRoute>
              <AdminMetricsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
        <Route path="/que-hace-la-app" element={<WhatAppDoesPage />} />
        <Route path="/como-empezar-en-5-minutos" element={<GetStartedFiveMinutesPage />} />
        <Route path="/precios-y-limites" element={<PricingLimitsPage />} />
        <Route path="/privacidad-sin-conexion-banco" element={<PrivacyNoBankConnectionPage />} />
        <Route path="/legal/aviso-legal" element={<LegalNoticePage />} />
        <Route path="/legal/privacidad-cookies" element={<PrivacyCookiesPage />} />
        <Route path="/legal/terminos-suscripcion" element={<TermsSubscriptionPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <SiteFooter />
      <CookieBanner />
    </div>
  );
}

export default App;
